export const BUSINESS = {
  name: "Mario Auto Body & Collision Repair",
  shortName: "Mario Auto Body",
  phone: "240-490-4836",
  phoneHref: "tel:+12404904836",
  email: "sales@mariocollision.com",
  address: "8846 Washington Blvd",
  city: "Jessup, MD 20794",
  hours: [
    { days: "Monday – Friday", time: "8:00 AM – 3:00 PM" },
    { days: "Saturday – Sunday", time: "Closed" },
  ],
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1653047256226-5abbfa82f1d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxyZWQlMjBzcG9ydHMlMjBjYXIlMjBkYXJrfGVufDB8fHx8MTc4NjM5ODI3Nnww&ixlib=rb-4.1.0&q=85",
  technician: "https://images.unsplash.com/photo-1711386689622-1cda23e10217?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxhdXRvJTIwYm9keSUyMHJlcGFpciUyMHRlY2huaWNpYW4lMjB3b3JraW5nfGVufDB8fHx8MTc4NjM5ODI1NXww&ixlib=rb-4.1.0&q=85",
  collision: "https://images.unsplash.com/photo-1673187139211-1e7ec3dd60ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxjYXIlMjBjb2xsaXNpb24lMjBkZW50JTIwcmVwYWlyfGVufDB8fHx8MTc4NjM5ODI1Nnww&ixlib=rb-4.1.0&q=85",
  paint: "https://images.unsplash.com/photo-1512080482556-ea648017576c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxhdXRvbW90aXZlJTIwc3ByYXklMjBwYWludGluZyUyMGNhcnxlbnwwfHx8fDE3ODYzOTgyNTV8MA&ixlib=rb-4.1.0&q=85",
  garage: "https://images.unsplash.com/photo-1577801622187-9a1076d049da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxtZWNoYW5pYyUyMGdhcmFnZSUyMGRhcmslMjBjaW5lbWF0aWN8ZW58MHx8fHwxNzg2Mzk4MjU1fDA&ixlib=rb-4.1.0&q=85",
  showroom: "https://images.unsplash.com/photo-1626621394541-b9a48e35a95d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBjYXIlMjBzaG93cm9vbSUyMGRhcmt8ZW58MHx8fHwxNzg2Mzk4MjU1fDA&ixlib=rb-4.1.0&q=85",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
